// src/pages/AboutPage.js
import React from 'react';

const AboutPage = () => {
  return (
    <div style={{ padding: '20px', lineHeight: '1.6', color: '#333' }}>
      <h1>About & Publisher Info</h1>
      <hr />
      
      <section style={{ marginBottom: '20px' }}>
        <h3>Publisher Details</h3>
        <p><strong>Entity Name:</strong> PRAGATHI PUBLICATIONS</p>
        <p><strong>Official Website:</strong> <a href="https://ainewstelugu.blogspot.com/" target="_blank" rel="noopener noreferrer">Visit our Official Site</a></p>
      </section>

    <section style={{ marginBottom: '20px', padding: '15px', backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
      <h3 style={{ color: '#333' }}>Contact Us</h3>
      <p style={{ color: '#666' }}>If you have any queries, concerns, or reports regarding the content, please contact us:</p>
      
      <p>
        <strong>Email: </strong> 
        <a 
          href="mailto:ainewstelugu@zohomail.in" 
          style={{ color: '#007bff', textDecoration: 'underline' }}
        >
          ainewstelugu@zohomail.in
        </a>
      </p>

      <p>
        <strong>Phone: </strong> 
        <a 
          href="tel:+919700881889" 
          style={{ color: '#007bff', textDecoration: 'underline' }}
        >
          +91 9700881889
        </a>
      </p>

      <p style={{ lineHeight: '1.6' }}>
        <strong>Address: </strong> 
        Office - Shop No.:306, 3rd floor, Jagadeesh Mall, Birla Compound, Kurnool, Andhra Pradesh - 518002, India 
      </p>

      <section style={{ marginBottom: '20px' }}>
        <h3>Developer Details 👨‍💻</h3>
        <p><strong>Name:</strong>Chaithanya Relampadu</p>
        <p><strong>contactDetails:</strong> <a>+919059900029</a></p>
      </section>

    </section>

    

      <section style={{ marginBottom: '20px', padding: '15px', backgroundColor: '#f9f9f9', border: '1px solid #ddd' }}>
        <h3>Disclaimer</h3>
        <p style={{ fontSize: '0.9rem' }}>
          AI News is a privately owned platform operated by PRAGATHI PUBLICATIONS. 
          <strong> This app is NOT affiliated with, authorized by, endorsed by, or in any way officially connected with any government entity or organization.</strong> 
          All government-related information (such as job listings) is sourced from official portals like india.gov.in and is provided for informational purposes only.
        </p>
      </section>
    </div>
  );
};

export default AboutPage;